<div class="container-fluid p-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">Listenverwaltung</h4>
    <button class="btn btn-outline-secondary" (click)="goBack()">
      <i class="bi bi-arrow-left"></i> Zurück
    </button>
  </div>

  <div class="card">
    <!-- Hinweis wenn nicht berechtigt -->
    @if (!canEdit) {
      <div class="alert alert-warning mb-0 rounded-0 rounded-top">
        <i class="bi bi-exclamation-triangle"></i> {{ disabledReason }}
      </div>
    }

    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-4">
          <label class="form-label mb-0">Liste:</label>
          <select class="form-select" [(ngModel)]="selectedListName" (ngModelChange)="selectList($event)">
            @for (list of availableLists; track list.name) {
              <option [value]="list.name">{{ list.displayName }}</option>
            }
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label mb-0">Suche:</label>
          <input type="text" class="form-control" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()"
            placeholder="Filter...">
        </div>
        <div class="col-md-4 text-end">
          <div>
            @if (storageType === 'database') {
              <span class="badge bg-success" title="Verbunden mit zentraler Datenbank">
                <i class="bi bi-database-check"></i> Datenbank
              </span>
            } @else {
              <span class="badge bg-info" title="Keine DB-Verbindung - Daten werden lokal gespeichert">
                <i class="bi bi-hdd"></i> Lokal
              </span>
            }
          </div>
          @if (listMetadata) {
            <div class="text-muted" style="font-size: 0.7rem;">
              Zuletzt geändert: {{ listMetadata.updatedBy }}, {{ formatDate(listMetadata.updatedAt) }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="mb-2">
        <div>
          <button class="btn btn-success btn-sm" (click)="startNewEntry()" [disabled]="!canEdit || showNewEntry || showFbfModal || showBodenartModal">
            <i class="bi bi-plus"></i> Neuer Eintrag
          </button>
          <span class="ms-3 text-muted">{{ filteredData.length }} Einträge</span>
        </div>
      </div>

      <!-- Neuer Eintrag Formular (für simple/valueNamePair) -->
      @if (showNewEntry && selectedConfig?.type !== 'feinbodenform') {
        <div class="alert alert-success p-2 mb-2">
          <div class="row align-items-center">
            @if (selectedConfig?.type === 'simple') {
              <div class="col">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="newValue"
                  placeholder="Neuer Wert" (keyup.enter)="addNewEntry()" (keyup.escape)="cancelNewEntry()">
              </div>
            } @else {
              <div class="col-5">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="newValue"
                  placeholder="Wert" (keyup.enter)="addNewEntry()" (keyup.escape)="cancelNewEntry()">
              </div>
              <div class="col-5">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="newName"
                  placeholder="Name" (keyup.enter)="addNewEntry()" (keyup.escape)="cancelNewEntry()">
              </div>
            }
            <div class="col-auto">
              <button class="btn btn-success btn-sm" (click)="addNewEntry()">
                <i class="bi bi-check"></i>
              </button>
              <button class="btn btn-secondary btn-sm" (click)="cancelNewEntry()">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        </div>
      }

      <!-- Tabelle -->
      <div class="table-responsive" style="max-height: 60vh; overflow-y: auto;">
        <table class="table table-sm table-striped table-hover">
          <thead class="sticky-top bg-light">
            <tr>
              @if (selectedConfig?.type === 'simple') {
                <th>Wert</th>
              } @else if (selectedConfig?.type === 'bodenartenTabelle') {
                <th>Kürzel</th>
                <th>LD ger.</th>
                <th>LD mit.</th>
                <th>LD hoch</th>
                <th>h2</th>
                <th>h3</th>
                <th>h4</th>
                <th>h5</th>
                <th>h6</th>
              } @else if (selectedConfig?.type === 'feinbodenform') {
                <th>FBF</th>
                <th>Anzeige</th>
                <th>Lokalname</th>
                <th>HBF (lang)</th>
                <th>HBF</th>
                <th>Nährkraft</th>
                <th>Seite</th>
              } @else {
                <th style="width: 30%">Wert</th>
                <th style="width: 50%">Name</th>
              }
              <th style="width: 100px">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            @for (item of filteredData; track $index) {
              <tr>
                @if (selectedConfig?.type === 'simple') {
                  <!-- Einfache Liste -->
                  @if (isEditing($index)) {
                    <td>
                      <input type="text" class="form-control form-control-sm" [(ngModel)]="editValue"
                        (keyup.enter)="saveEdit()" (keyup.escape)="cancelEdit()">
                    </td>
                  } @else {
                    <td>{{ item }}</td>
                  }
                } @else if (selectedConfig?.type === 'bodenartenTabelle') {
                  <!-- BodenartenTabelle -->
                  <td>{{ item.name }}</td>
                  <td>{{ item.Lagerungsdichte?.gering }}</td>
                  <td>{{ item.Lagerungsdichte?.mittel }}</td>
                  <td>{{ item.Lagerungsdichte?.hoch }}</td>
                  <td>{{ item.Humusgehalt?.h2 }}</td>
                  <td>{{ item.Humusgehalt?.h3 }}</td>
                  <td>{{ item.Humusgehalt?.h4 }}</td>
                  <td>{{ item.Humusgehalt?.h5 }}</td>
                  <td>{{ item.Humusgehalt?.h6 }}</td>
                } @else if (selectedConfig?.type === 'feinbodenform') {
                  <!-- Feinbodenform -->
                  <td>{{ item.FBF }}</td>
                  <td>{{ item.FBF_display }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.HBF_lang || '-' }}</td>
                  <td>{{ item.HBF }}</td>
                  <td>{{ item.NKr }}</td>
                  <td>{{ item.Seite || '-' }}</td>
                } @else {
                  <!-- Value/Name Paar -->
                  @if (isEditing($index)) {
                    <td>
                      <input type="text" class="form-control form-control-sm" [(ngModel)]="editValue"
                        (keyup.enter)="saveEdit()" (keyup.escape)="cancelEdit()">
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm" [(ngModel)]="editName"
                        (keyup.enter)="saveEdit()" (keyup.escape)="cancelEdit()">
                    </td>
                  } @else {
                    <td>{{ item.value }}</td>
                    <td>{{ item.name }}</td>
                  }
                }
                <td>
                  @if (isEditing($index) && selectedConfig?.type !== 'feinbodenform') {
                    <button class="btn btn-success btn-sm me-1" (click)="saveEdit()" title="Speichern">
                      <i class="bi bi-check"></i>
                    </button>
                    <button class="btn btn-secondary btn-sm" (click)="cancelEdit()" title="Abbrechen">
                      <i class="bi bi-x"></i>
                    </button>
                  } @else {
                    <button class="btn btn-outline-primary btn-sm me-1" (click)="startEdit($index)" title="Bearbeiten" [disabled]="!canEdit">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button class="btn btn-outline-danger btn-sm" (click)="deleteEntry($index)" title="Löschen" [disabled]="!canEdit">
                      <i class="bi bi-trash"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end">
      <div class="d-flex gap-2 align-items-center">
        @if (hasChanges) {
          <span class="text-warning me-2">
            <i class="bi bi-exclamation-triangle"></i> Ungespeicherte Änderungen
          </span>
        }
        <button class="btn btn-outline-secondary" (click)="discardChanges()" [disabled]="!hasChanges"
          title="Verwirft alle ungespeicherten Änderungen">
          <i class="bi bi-x-circle"></i> Verwerfen
        </button>
        <button class="btn btn-primary" (click)="saveList()" [disabled]="!canEdit || !hasChanges">
          <i class="bi bi-download"></i> Speichern
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Feinbodenform Modal -->
@if (showFbfModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ fbfEditMode === 'new' ? 'Neue Feinbodenform' : 'Feinbodenform bearbeiten' }}
          </h5>
          <button type="button" class="btn-close" (click)="closeFbfModal()"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-md-4">
              <label class="form-label">FBF</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.FBF" placeholder="z.B. AbdLU">
            </div>
            <div class="col-md-4">
              <label class="form-label">Anzeige (FBF_display)</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.FBF_display" placeholder="z.B. Ab dLU">
            </div>
            <div class="col-md-4">
              <label class="form-label">Lokalname</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.name" placeholder="z.B. Annaburger">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">HBF</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.HBF" placeholder="z.B. l/s UA">
            </div>
            <div class="col-md-6">
              <label class="form-label">HBF (lang)</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.HBF_lang" placeholder="z.B. Decklehm-Grauamphigley">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label class="form-label">Nährkraftstufe</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.NKr" placeholder="z.B. K">
            </div>
            <div class="col-md-3">
              <label class="form-label">Seite</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.Seite" placeholder="z.B. 398/1">
            </div>
            <div class="col-md-3">
              <label class="form-label">Hinweis</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.Hw" placeholder="optional">
            </div>
            <div class="col-md-3">
              <label class="form-label">Serie</label>
              <input type="text" class="form-control" [(ngModel)]="fbfEdit.Serie" placeholder="z.B. VIII + o -">
            </div>
          </div>

          <!-- Zuordnungen -->
          <div class="card">
            <div class="card-header py-2">
              <strong>Zuordnungen</strong>
            </div>
            <div class="card-body p-2">
              <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th style="width: 40%">Wasserform</th>
                      <th style="width: 40%">STFG</th>
                      <th style="width: 20%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (key of zuordnungKeys; track key) {
                      <tr>
                        <td>{{ key }}</td>
                        <td>
                          <input type="text" class="form-control form-control-sm"
                            [ngModel]="fbfEdit.zuordnung[key]"
                            (ngModelChange)="updateZuordnung(key, $event)">
                        </td>
                        <td>
                          <button class="btn btn-outline-danger btn-sm" (click)="removeZuordnung(key)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    }
                    <!-- Neue Zuordnung -->
                    <tr>
                      <td>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="newZuordnungKey"
                          placeholder="Neue Wasserform" (keyup.enter)="addZuordnung()">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="newZuordnungValue"
                          placeholder="STFG" (keyup.enter)="addZuordnung()">
                      </td>
                      <td>
                        <button class="btn btn-success btn-sm" (click)="addZuordnung()">
                          <i class="bi bi-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeFbfModal()">Abbrechen</button>
          <button type="button" class="btn btn-primary" (click)="saveFbfEntry()">Übernehmen</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Bodenart Modal -->
@if (showBodenartModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ bodenartEditMode === 'new' ? 'Neue Bodenart' : 'Bodenart bearbeiten' }}
          </h5>
          <button type="button" class="btn-close" (click)="closeBodenartModal()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Kürzel</label>
            <input type="text" class="form-control" [(ngModel)]="bodenartEdit.name" placeholder="z.B. mk">
          </div>
          <div class="card mb-3">
            <div class="card-header py-2"><strong>Lagerungsdichte (nFK je dm)</strong></div>
            <div class="card-body p-2">
              <div class="row g-2">
                <div class="col-4">
                  <label class="form-label">gering</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Lagerungsdichte.gering" step="0.1">
                </div>
                <div class="col-4">
                  <label class="form-label">mittel</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Lagerungsdichte.mittel" step="0.1">
                </div>
                <div class="col-4">
                  <label class="form-label">hoch</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Lagerungsdichte.hoch" step="0.1">
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header py-2"><strong>Humusgehalt-Zuschlag</strong></div>
            <div class="card-body p-2">
              <div class="row g-2">
                <div class="col">
                  <label class="form-label">h2</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Humusgehalt.h2" step="0.1">
                </div>
                <div class="col">
                  <label class="form-label">h3</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Humusgehalt.h3" step="0.1">
                </div>
                <div class="col">
                  <label class="form-label">h4</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Humusgehalt.h4" step="0.1">
                </div>
                <div class="col">
                  <label class="form-label">h5</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Humusgehalt.h5" step="0.1">
                </div>
                <div class="col">
                  <label class="form-label">h6</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bodenartEdit.Humusgehalt.h6" step="0.1">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeBodenartModal()">Abbrechen</button>
          <button type="button" class="btn btn-primary" (click)="saveBodenartEntry()">Übernehmen</button>
        </div>
      </div>
    </div>
  </div>
}
